<template>
  <div
    id="vendor-assess-review-notes"
    class="tw-flex tw-flex-col tw-gap-[20px]"
  >
    <div class="tw-flex tw-items-center tw-justify-between">
      <div class="tw-text-[20px] tw-text-[#211F58] tw-font-semibold">
        {{ title }}
      </div>
    </div>
    <TextArea1
      v-show="!isLoading"
      id="vendor-assessment-note-input"
      class="tw-min-h-[220px] tw-text-[15px] tw-font-normal tw-color-[#231F20] !tw-font-Poppins !tw-p-[25px]"
      :class-name="'!tw-bg-white'"
      data-cy="vendor-assessment-note-input"
      :placeholder="
        getComponentUiText(
          'app-assessments-vendor-questions-note-placeholder-1',
        )
      "
      :no-resize="true"
      :value="notes"
      :disabled="disable"
      maxlength="600"
      @update:value="($event) => (notes = $event)"
      @focusout="
        () => {
          emits('update:value', notes);
          emits('update:blur', notes);
        }
      "
    />
    <div
      v-if="isLoading"
      class="custom-global-skeleton tw-bg-[#ffffff] tw-h-[220px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
    />
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { ref, watch } from "vue";
import TextArea1 from "../common/textArea1.vue";

const props = defineProps({
  note: {
    type: String,
    default: "",
  },
  disable: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-assessments-vendor-questions-note-title-1",
    ),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:value", "update:blur"]);

const notes = ref(props.note);

watch(
  () => props.note,
  (value) => {
    notes.value = value;
  },
);
</script>
